<div class="login-form-wrap">
    <router-outlet />
</div>
